export const REDUCER_KEY_STRUCTURE_OPTIONS = 'structureOption';

export const STRUCTURE_OPTION_CHECKED = 'rs/StructureOptions/OPTION_CHECKED';
export const STRUCTURE_OPTION_CLEAR = 'rs/StructureOptions/STRUCTURE_OPTION_CLEAR';

export const FETCH_MENU_OPTIONS = 'rs/StructureOptions/FETCH_MENU_OPTIONS';
export const FETCH_MENU_OPTIONS_SUCCESS = 'rs/StructureOptions/FETCH_MENU_OPTIONS_SUCCESS';
export const FETCH_MENU_OPTIONS_FAILED = 'rs/StructureOptions/FETCH_MENU_OPTIONS_FAILED';

export const CLEAN_STATE = 'rs/StructureOptions/CLEAN_STATE';

export class StructureOptionType {
  static CUSTOMER_ICON = 'StructureOptionType.CUSTOMER_ICON';

  static SHOPPING_CARD = 'StructureOptionType.SHOPPING_CARD';

  static ZOOM = 'StructureOptionType.ZOOM';

  static OPTIONS = 'StructureOptionType.OPTIONS';

  static DETAILS = 'StructureOptionType.DETAILS';

  static get allTypes() {
    return [
      StructureOptionType.CUSTOMER_ICON,
      StructureOptionType.SHOPPING_CARD,
      StructureOptionType.ZOOM,
      StructureOptionType.DETAILS,
      StructureOptionType.OPTIONS,
    ];
  }
}
